import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/profiles'
import Component from 'components/Profiles'

export default createListViewContainer({ actions, selectors: selectors.profiles })(Component)
